var React = require('react');

function SmallArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-956.000000, -407.000000)","strokeWidth":"2"},React.createElement("g",{"transform":"translate(957.000000, 401.000000)"},React.createElement("polyline",{"transform":"translate(3.000000, 13.000000) rotate(-90.000000) translate(-3.000000, -13.000000) ","points":"-3 10 3 16 9 10"})))));
}

SmallArrowRight.defaultProps = {"width":"9px","height":"14px","viewBox":"0 0 9 14","version":"1.1"};

module.exports = SmallArrowRight;

SmallArrowRight.default = SmallArrowRight;
